(function () {
  if (window.__mcBuybox) return;
  window.__mcBuybox = true;
  function relocateWishlist() {
    var media = document.querySelector('.t4s-product__media-wrapper');
    if (!media) return;
    if (media.querySelector('.mc-pdp-gallery-wish')) return;
    var wish = document.querySelector(
      '.t4s-product__info-wrapper .t4s-pr-wishlist[data-action-wishlist]',
    );
    if (!wish) return;
    wish.classList.add('mc-pdp-gallery-wish');
    wish.classList.remove('t4s-tooltip-actived');
    wish.removeAttribute('data-tooltip');
    media.appendChild(wish);
  }
  if (document.readyState !== 'loading') relocateWishlist();
  else document.addEventListener('DOMContentLoaded', relocateWishlist);

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('.t4s-sticky-atc__atc');
      if (!btn) return;
      if (window.innerWidth >= 768) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (btn.classList.contains('mc-sticky-adding')) return;
      var form = document.querySelector('form[action*="/cart/add"]');
      var idEl = form && form.querySelector('[name="id"]');
      var vid = (idEl && idEl.value) || btn.getAttribute('data-variant-id');
      if (!vid) return;
      var qEl = form && form.querySelector('[name="quantity"], .t4s-quantity-input');
      var qty = qEl ? parseInt(qEl.value, 10) || 1 : 1;
      window.__mcStickyAdd = true;
      btn.classList.add('mc-sticky-adding');
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: qty }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(function () {})
        .finally(function () {
          setTimeout(function () {
            btn.classList.remove('mc-sticky-adding');
          }, 400);
        });
    },
    true,
  );
})();
